var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React, { useContext } from "react";
import { Box, Heading, ResponsiveContext, Text } from "grommet";
import styled from "styled-components";
import { Location } from "grommet-icons";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { getDate } from "../../../utils/date";
var StyledText = styled(Text)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  border-right: 1px solid black;\n  padding-right: 1rem;\n",
    ]))
);
export var ActivitySection = function ActivitySection(_ref) {
  var activities = _ref.activities;
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 2,
        margin: {
          bottom: "3rem",
        },
      },
      "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
    ),
    /*#__PURE__*/ React.createElement(
      Text,
      null,
      "\u041E\u0442\u043A\u0443\u0434\u0430 \u0432\u044B \u0437\u0430\u0445\u043E\u0434\u0438\u043B\u0438 \u0432 \u0432\u0430\u0448 \u043F\u0440\u043E\u0444\u0438\u043B\u044C"
    ),
    activities.length > 0
      ? activities.map(function (el, i) {
          return /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              justify: "start",
              align: "start",
              height: {
                max: "100px",
              },
              key: el.method + i,
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                width: "100%",
                pad: {
                  vertical: "24px",
                },
                style: {
                  borderBottom: "1px solid black",
                },
                flex: true,
                direction: "row",
              },
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  margin: {
                    right: "1rem",
                  },
                },
                /*#__PURE__*/ React.createElement(Location, {
                  size: "medium",
                  color: "black",
                })
              ),
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  flex: true,
                  direction: "column",
                },
                /*#__PURE__*/ React.createElement(
                  Heading,
                  {
                    level: 6,
                  },
                  el.city ||
                    "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u0445\u0443\u0442\u043E\u0440",
                  ", ",
                  el.country ||
                    "\u0414\u0430\u043B\u0435\u043A\u043E\u0435 \u0417\u0430\u0431\u0443\u0433\u043E\u0440\u044C\u0435"
                ),
                /*#__PURE__*/ React.createElement(
                  Box,
                  {
                    flex: true,
                    direction: "row",
                    height: {
                      max: "16px",
                    },
                  },
                  /*#__PURE__*/ React.createElement(
                    StyledText,
                    {
                      size: isMobileWidth ? "xsmall" : "small",
                      margin: {
                        right: isMobileWidth ? "0.3rem" : "1rem",
                      },
                    },
                    i === 0
                      ? "Сессия активна"
                      : getDate(el.temp).date +
                          " " +
                          getDate(el.temp).month +
                          " " +
                          getDate(el.temp).year
                  ),
                  /*#__PURE__*/ React.createElement(
                    StyledText,
                    {
                      size: isMobileWidth ? "xsmall" : "small",
                      margin: {
                        right: isMobileWidth ? "0.3rem" : "1rem",
                      },
                    },
                    el.os
                  ),
                  /*#__PURE__*/ React.createElement(
                    Text,
                    {
                      size: isMobileWidth ? "xsmall" : "small",
                    },
                    "\u0427\u0435\u0440\u0435\u0437 ",
                    el.browser
                  )
                )
              )
            )
          );
        })
      : "Нет данных об активности профиля."
  );
};
